export default {
    type: 'dom',
    init: function (GG) {
        if (typeof GG.$ !== 'undefined') {
            GG.customSelect = this.plugin.bind(GG);
            GG.log('CustomSelect plugin loaded.');
        }
        else {
            GG.log('CustomSelect plugin needs jQuery.');
        }
    },
    plugin: function (containers, callback) {
        var $ = this.$;
        var app = this;
        var selects = [];
        if (containers.length) {
            $('select', containers).each(function () {
                var $parent = $(this).parent();
                var $options = $(this).find('option');
                var required = $(this).attr('required');
                var disabled = $(this).attr('disabled');
                if ($parent.is('.customSelect')) {
                    console.log('Already is customSelect: ' + $(this));
                    return false;
                }
                $parent.addClass('customSelect default');
                if (disabled)
                    $parent.addClass('disabled');
                $parent.data('callback', callback);
                var $placeholder = $('<div/>', {
                    class: 'customSelect__placeholder'
                }).appendTo($parent);
                var $list = $('<ul/>', {
                    class: 'customSelect__list'
                });
                var $selected = $(this).find('option:selected');
                var optionSelected = false;
                $options.each(function () {
                    var $option = $(this);
                    var optClass = $option.attr('class');
                    var $entry = $('<li/>', {
                        class: 'list__entry ' + (optClass || '')
                    });
                    var $link;
                    var style;
                    if (!required || (required && $option.val())) {
                        $entry.appendTo($list);
                        $link = $('<a/>', {
                            class: 'entry__link',
                            href: '#'
                        })
                            .data('id', $option.val())
                            .html($option.html())
                            .appendTo($entry);
                    }
                    if (!$option.val()) {
                        $entry.addClass('list__entry_empty');
                    }
                    var $optionPrefix;
                    if ((style = $option.attr('style'))) {
                        $optionPrefix = $('<span/>', {
                            class: 'customSelect__optionprefix',
                            style: style
                        });
                        $link.prepend($optionPrefix);
                    }
                    if ($option.attr('selected')) {
                        optionSelected = true;
                        $entry.addClass('list__entry_current');
                        $placeholder.html(($optionPrefix ? $optionPrefix[0].outerHTML : '') + $option.html());
                        if ($option.val()) {
                            $parent.removeClass('default');
                        }
                    }
                    if ($option.attr('disabled')) {
                        $entry.addClass('list__entry_disabled');
                    }
                });
                if (!optionSelected) {
                    var $defaultOption = $($options[0]), $optionPrefix = void 0;
                    var style = $defaultOption.attr('style');
                    if (style) {
                        $optionPrefix = $('<span/>', {
                            class: 'customSelect__optionprefix',
                            style: style
                        });
                    }
                    $defaultOption.attr('selected', 'selected');
                    $placeholder.html(($optionPrefix ? $optionPrefix[0].outerHTML : '') + $defaultOption.html());
                }
                if (app.isMobile) {
                    $parent.addClass('mobile');
                }
                else {
                    $('<input/>', {
                        name: $(this).attr('name'),
                        type: 'hidden',
                        value: $selected[0].value
                    }).appendTo($parent);
                    $list.appendTo($parent);
                    $(this).remove();
                }
                selects.push($parent);
            });
            if (!app.customSelectInit) {
                app.customSelectInit = true;
                $('body')
                    .on('click', '.customSelect__list .entry__link', function (e) {
                    e.stopPropagation();
                    if ($(this)
                        .closest('.list__entry')
                        .is('.list__entry_disabled')) {
                        e.preventDefault();
                        return false;
                    }
                    var $parent = $(this).closest('.customSelect'), value = $(this).data('id'), title = $(this).html(), element = null;
                    if (!app.isMobile) {
                        element = $parent.find('input[type=hidden]').val(value);
                    }
                    $parent.find('.customSelect__placeholder').html(title);
                    if (!value) {
                        $parent.addClass('default');
                    }
                    else {
                        $parent.removeClass('default');
                    }
                    $parent.removeClass('opened');
                    if ($parent.data('callback') && typeof $parent.data('callback') === 'function')
                        $parent.data('callback')(element[0], value);
                })
                    .on('click', '.customSelect', function (e) {
                    if ($(this).is('.disabled'))
                        return false;
                    $('.customSelect')
                        .not(this)
                        .removeClass('opened');
                    $(this).toggleClass('opened');
                    e.stopPropagation();
                    e.preventDefault();
                })
                    .on('click', function () {
                    $('.customSelect').removeClass('opened');
                })
                    .on('change', '.customSelect select', function () {
                    var $parent = $(this).closest('.customSelect'), $selected = $('option:selected', this), text = $selected.html(), value = $selected.val();
                    if (!value) {
                        $parent.addClass('default');
                    }
                    else {
                        $parent.removeClass('default');
                    }
                    $(this)
                        .closest('.customSelect')
                        .find('.customSelect__placeholder')
                        .html(text)
                        .end()
                        .removeClass('opened');
                    if ($parent.data('callback') && typeof $parent.data('callback') === 'function')
                        $parent.data('callback')(this, value);
                });
                $.fn.customSelect = function (value) {
                    if (typeof value === 'undefined') {
                        return $(this)
                            .find(app.isMobile ? 'select option:selected' : 'input')
                            .val();
                    }
                    else {
                        if (app.isMobile) {
                            $(this)
                                .find('select')
                                .val(value)
                                .trigger('change');
                        }
                        else {
                            $(this)
                                .find('.customSelect__list .entry__link')
                                .each(function () {
                                if ($(this).data('id') === value) {
                                    $(this).trigger('click');
                                }
                            });
                        }
                    }
                };
            }
            return function (value) {
                if (typeof value === 'undefined') {
                    console.log($(this));
                    return $(this)
                        .find(app.isMobile ? 'select option:selected' : 'input')
                        .val();
                }
                else {
                    for (var i = 0, k = selects.length; i < k; i++) {
                        var select = selects[i];
                        if (app.isMobile) {
                            $(select)
                                .find('select')
                                .val(value)
                                .trigger('change');
                        }
                        else {
                            $(select)
                                .find('.customSelect__list .entry__link')
                                .each(function () {
                                if ($(this).data('id') === value) {
                                    $(this).trigger('click');
                                }
                            });
                        }
                    }
                }
            };
        }
    }
};
